<template>
  <div class="bt bg-F6F6F6">
    <div v-if="noticeList.length">
      <p class="c-171A1D-40 p-0-16 h-36 lh-36 font-26" v-if="moduleType !== 95"
        >默认通知角色</p
      >
      <div class="p-0-16">
        <md-list
          class="bd-radio-8 hidden"
          :textline="2"
          arrow
          :class="{ 'mt-12': moduleType === 95 }"
        >
          <md-list-item
            @click="
              handlerHeardTeacher(
                $event,
                item.noticeGroupName,
                item.noticeGroupId,
                item.noticeType,
                false
              )
            "
            v-for="(item, index) in noticeList"
            :key="index"
            :title="item.noticeGroupName"
            :sub-title="item.info"
          ></md-list-item>
        </md-list>
      </div>
    </div>
    <div v-if="customizeList.length">
      <p class="c-171A1D-40 p-0-16 h-36 lh-36 font-26">自定义通知组</p>
      <div class="p-0-16">
        <md-list class="bd-radio-8 hidden" :textline="2" arrow>
          <md-list-item
            @click="
              handlerHeardTeacher(
                $event,
                item.noticeGroupName,
                item.noticeGroupId,
                item.noticeType,
                true
              )
            "
            v-for="(item, index) in customizeList"
            :key="index"
            :title="item.noticeGroupName"
            :sub-title="item.info"
          ></md-list-item>
        </md-list>
      </div>
    </div>
    <div class="hidden p-0-16 bd-radio-8" v-if="allowAdd">
      <div
        @click="handlerAddRole"
        class="fb fb-cross-center h-56 lh-56 bg-FFFFFF c-006AFE font-34 p-0-16 m-12-0 bd-radio-8"
      >
        <i class="iconfont font-44 mr-9">&#xe66c;</i>添加自定义通知组
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixin'
import API from '@/api'
import { MODULE_NAME, INFO_TYPE } from '@/utils/noticeUtils'

export default {
  mixins: [mixin],
  components: {},
  props: {
    //   attendance: 1 考勤;  leave: 2 请假;  dorm: 4 宿管;   classover: 30 班级放学 95 智慧停车;
    moduleId: {
      type: Number,
      default: 1
    },
    // 1 请假 2 考勤
    moduleType: {
      type: Number,
      default: 1
    },
    allowAdd: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      noticeList: [],
      customizeList: []
    }
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.fetchGetGroupRange()
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    fetchGetGroupRange() {
      API.getNoticeGroups({
        moduleType: this.moduleType,
        noticeVersion: 1
      })
        .then(res => {
          res.forEach(element => {
            element.info = ''
            ;(element.noticeDtoList || []).forEach(info => {
              if (info.noticeStyleType === '1') {
                // 考勤通知家长无法收到迟到字段,需要去掉
                if (
                  this.moduleType !== 2 ||
                  info.noticeEventType !== 3 ||
                  element.noticeGroupName !== '家长'
                ) {
                  element.info +=
                    INFO_TYPE[this.moduleId][info.noticeEventType] + '、'
                }
              }
            })
            element.info = element.info.substring(0, element.info.length - 1)
            if (element.noticeType !== 5) {
              this.noticeList.push(element)
            } else {
              this.customizeList.push(element)
            }
          })
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },
    handlerHeardTeacher(id, name, noticeGroupId, noticeType, customization) {
      this.$router.push({
        path: `/${MODULE_NAME[this.moduleId]}/noticeDetail`,
        query: {
          name,
          noticeGroupId,
          noticeType,
          customization
        }
      })
    },
    handlerAddRole() {
      this.$router.push({
        path: `/${MODULE_NAME[this.moduleId]}/noticeDetail`,
        query: {
          customization: true,
          noticeType: 5
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.addRole {
  margin-top: 16px;
  color: #006afe;
  background: #ffffff;
  font-size: 17px;
  text-indent: 16px;
}
</style>
